!function() {
  class t extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.productForm = this.querySelector("product-form [data-form]"), this.stickyAddToCart = this.querySelector("[data-sticky-add-to-cart]"), 
      this.footer = document.querySelector("footer"), this.isPastProductForm = !1, this.isFooterVisible = !1, 
      this.productForm && this.stickyAddToCart && (this.initProductFormObserver(), this.updateStickyCartVisibility()), 
      this.footer && this.stickyAddToCart && this.initFooterObserver();
    }
    disconnectedCallback() {
      this.productFormObserver && this.productFormObserver.disconnect(), this.footerObserver && this.footerObserver.disconnect();
    }
    updateStickyCartVisibility() {
      if (!this.stickyAddToCart) return;
      this.isPastProductForm && !this.isFooterVisible ? this.stickyAddToCart.classList.remove("translate-y-full", "pointer-events-none") : this.stickyAddToCart.classList.add("translate-y-full", "pointer-events-none");
    }
    initProductFormObserver() {
      this.productFormObserver = new IntersectionObserver(t => {
        t.forEach(t => {
          const {isIntersecting: r, boundingClientRect: e} = t;
          this.isPastProductForm = !r && e.y < 0, this.updateStickyCartVisibility();
        });
      }, {
        root: null,
        threshold: 0
      }), this.productFormObserver.observe(this.productForm);
    }
    initFooterObserver() {
      this.footerObserver = new IntersectionObserver(t => {
        t.forEach(t => {
          this.isFooterVisible = t.isIntersecting, this.updateStickyCartVisibility();
        });
      }, {
        root: null,
        threshold: 0
      }), this.footerObserver.observe(this.footer);
    }
  }
  customElements.get("product-wrapper") || customElements.define("product-wrapper", t);
}();